import { render, staticRenderFns } from "./TrendingArticles.vue?vue&type=template&id=f275aa78&scoped=true"
import script from "./TrendingArticles.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrendingArticles.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrendingArticles.vue?vue&type=style&index=0&id=f275aa78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f275aa78",
  null
  
)

export default component.exports